import React from 'react';
export function Integrations() {
  return <div data-id="element-2372">
      <div className="flex justify-between items-center mb-6" data-id="element-2373">
        <h1 className="text-2xl font-bold" data-id="element-2374">Integrations</h1>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-2375">
        <div className="bg-white rounded-lg shadow p-6" data-id="element-2376">
          <div className="flex items-center justify-between" data-id="element-2377">
            <div data-id="element-2378">
              <h2 className="text-lg font-medium" data-id="element-2379">Email Provider</h2>
              <p className="text-sm text-neutral-500 mt-1" data-id="element-2380">
                Connect your email service for sending communications
              </p>
            </div>
            <button className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700" data-id="element-2381">
              Connect
            </button>
          </div>
        </div>
        <div className="bg-white rounded-lg shadow p-6" data-id="element-2382">
          <div className="flex items-center justify-between" data-id="element-2383">
            <div data-id="element-2384">
              <h2 className="text-lg font-medium" data-id="element-2385">SMS Provider</h2>
              <p className="text-sm text-neutral-500 mt-1" data-id="element-2386">
                Connect your SMS service for text notifications
              </p>
            </div>
            <button className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700" data-id="element-2387">
              Connect
            </button>
          </div>
        </div>
        <div className="bg-white rounded-lg shadow p-6" data-id="element-2388">
          <div className="flex items-center justify-between" data-id="element-2389">
            <div data-id="element-2390">
              <h2 className="text-lg font-medium" data-id="element-2391">Calendar</h2>
              <p className="text-sm text-neutral-500 mt-1" data-id="element-2392">
                Sync with Google Calendar or Outlook
              </p>
            </div>
            <button className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700" data-id="element-2393">
              Connect
            </button>
          </div>
        </div>
        <div className="bg-white rounded-lg shadow p-6" data-id="element-2394">
          <div className="flex items-center justify-between" data-id="element-2395">
            <div data-id="element-2396">
              <h2 className="text-lg font-medium" data-id="element-2397">DocuSign API</h2>
              <p className="text-sm text-neutral-500 mt-1" data-id="element-2398">
                Connect to DocuSign for electronic signature collection
              </p>
            </div>
            <button className="bg-green-600 text-white px-4 py-2 rounded hover:bg-green-700" data-id="element-2399">
              Connected
            </button>
          </div>
        </div>
        <div className="bg-white rounded-lg shadow p-6" data-id="element-2400">
          <div className="flex items-center justify-between" data-id="element-2401">
            <div data-id="element-2402">
              <h2 className="text-lg font-medium" data-id="element-2403">Ring Central API</h2>
              <p className="text-sm text-neutral-500 mt-1" data-id="element-2404">
                Connect to Ring Central for voice, video, and messaging
              </p>
            </div>
            <button className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700" data-id="element-2405">
              Connect
            </button>
          </div>
        </div>
        <div className="bg-white rounded-lg shadow p-6" data-id="element-2406">
          <div className="flex items-center justify-between" data-id="element-2407">
            <div data-id="element-2408">
              <h2 className="text-lg font-medium" data-id="element-2409">Equifax API</h2>
              <p className="text-sm text-neutral-500 mt-1" data-id="element-2410">
                Connect to Equifax for credit checks and financial data
              </p>
            </div>
            <button className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700" data-id="element-2411">
              Connect
            </button>
          </div>
        </div>
      </div>
    </div>;
}